import React, { useCallback, useEffect, useState } from 'react';
import { Select } from 'antd';
import ProductList from './ProductList';
import Header from './Header';
import Footer from './Footer';
import { useId } from 'react';

const Home = () => {
    const [collapsed, setCollapsed] = useState(true);
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState(null);
    const [category, setCategory] = useState(null);
    const [dropdownItems, setDropdownItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(12);
    const [totalProducts, setTotalProducts] = useState(0);
    const [loading, setLoading] = useState(false);
    const uid = useId();

    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    };

    const onSearch = (e) => {
        setTimeout(() => {
            setFilteredProducts(e.target.value);
            setCurrentPage(1);
        }, 1000);
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const categoryHandler = useCallback((value) => {
        setFilteredProducts(null);
        setCategory(value);
        setCurrentPage(1);
    }, []);

    const getDropdownItems = useCallback(async () => {
        fetch('https://dummyjson.com/products/categories')
            .then((res) => res.json())
            .then((data) => {
                const formattedData = data.map((item) => ({
                    label: item.toString(),
                    value: item.toString(),
                }));
                setDropdownItems(formattedData);
            });
    }, []);


    const getProducts = useCallback(() => {
        setLoading(true);
        let url = 'https://dummyjson.com/products';
        if (category != null && filteredProducts == null) {
            url += `/category/${category}`;
        }
        if (category != null && filteredProducts != null) {
            url += `/category/${category}`;
        }
        if (filteredProducts != null && category == null) {
            url += `/search?q=${filteredProducts}&`;
        }
        url += `?skip=${(currentPage - 1) * itemsPerPage}&limit=${itemsPerPage}`;

        fetch(url)
            .then((res) => res.json())
            .then((data) => {
                if (data.products.length > 0) {
                    if (category && filteredProducts) {
                        let result = data.products.filter(product => product.title.toLowerCase().includes(filteredProducts.toLowerCase()));
                        console.log(result.length);
                        if (result.length) {
                            setProducts(result);
                            setTotalProducts(result.length);
                        } else {
                            setProducts(null);
                        }
                    }
                    else {
                        setProducts(data.products);
                        setTotalProducts(data.total);
                    }
                } else {
                    setProducts(null);
                }
            })
            .catch((err) => {
                setProducts(null);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [currentPage, category, filteredProducts]);

    useEffect(() => {
        getDropdownItems();
        getProducts();
    }, [currentPage, category, filteredProducts, getDropdownItems, getProducts]);

    return (
        <>
            <div className="container">
                <Header collapsed={collapsed} toggleNavbar={toggleNavbar} onSearch={onSearch} search={filteredProducts} />

                <div className=' bg-color rounded-3 py-2 my-3'>
                    <div className='inner-height'>
                        <h5 className='fw-bold text-white mb-2'>Lorem Ipusm</h5>
                        <p className='tag-line mb-3'>Slash Sales begin in june, Get up to 80% Discount on all products <span className='fw-bold text-white'>Read More</span> </p>
                    </div>
                </div>

                <div className='my-3'>
                    <Select style={{ width: 280 }}
                        placeholder="Select Category"
                        optionFilterProp="children"
                        onChange={categoryHandler}
                        options={dropdownItems}
                        size='middle'
                        allowClear
                    />
                </div>

                {products != null ? (
                    <ProductList
                        key={uid}
                        products={products}
                        total={totalProducts}
                        pageSize={itemsPerPage}
                        skip={(currentPage - 1) * itemsPerPage}
                        onPageChange={handlePageChange}
                        loading={loading}
                    />
                ) : (
                    <h5 className='text-center'>No Products available</h5>
                )}


                <Footer />
            </div>
        </>
    );
};

export default Home;
